export const USER_STATUS = {
  ACTIVE: 'Active',
}
export const USER_ACCESS = {
  CHANGEORDERALLOWED: 'Change_Order_Allowed',
  CHANGEORDERMANAGEMENT: 'Change_Order_Management',
}

export const USER_ROLE = {
  PLATFORM_ADMIN: 'Platform Admin',
  TOP_ADMIN: 'admin',
  VIEWER: 'viewer',
  CASH_CONNECT: 'CashConnect',
  GROUPMANAGER: 'groupmanager',
  STOREMANAGER: 'storemanager',
  MANAGER: 'storemanager',
  CORPORATE: 'corporate'
}
